module.exports = __webpack_public_path__ + "img/cert1.3f22e44e.png";